import { Text, TextProps } from '@sendoutcards/quantum-design-ui'
import { animate } from 'framer-motion'
import { useEffect, useState } from 'src/hooks'

type Props = {
  amount: number
  duration?: number
  textProps?: TextProps
}

export function MotionCounter({ amount, duration = 0.8, textProps }: Props) {
  const [displayValue, setDisplayValue] = useState(0)

  useEffect(() => {
    const controls = animate(0, amount, {
      duration,
      ease: 'easeOut',
      onUpdate(value) {
        setDisplayValue(Math.floor(value))
      },
    })

    return () => controls.stop()
  }, [amount, duration])

  return (
    <Text
      type="subtitle"
      weight="extraBold"
      color="primaryHeading"
      {...textProps}
      content={displayValue.toLocaleString()}
    />
  )
}
